module.exports = __webpack_public_path__ + "static/media/mysql.2fefb95a.svg";